export function appBaseHrefFactory(): string {
  if (typeof document === 'undefined') {
    return '/';
  }
  const raw = document.querySelector('base')?.getAttribute('href')?.trim() || '/';
  if (raw === '.' || raw === './') {
    return '/';
  }
  try {
    const path = new URL(raw, 'http://local.invalid').pathname;
    if (path === '/') {
      return '/';
    }
    return path.endsWith('/') ? path.slice(0, -1) : path;
  } catch {
    return raw.replace(/\/$/, '') || '/';
  }
}
